import { useContext } from "react";
import { CustomModalContext } from "store/CustomModalProvider";

const useModal = () => useContext(CustomModalContext);

export default useModal;
